import React, { useRef, useState } from "react";
import ButtonGroup from "@mui/material/ButtonGroup";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import { getClassName } from "@sscs/utils";
import { ArrowDropDownIcon } from "../../icons";
import { Button } from "../index";
import styles from "./splitButton.module.scss";
function SplitButton({ id, "aria-label": ariaLabel, label, tooltipTitle, disabled = false, startIcon, matchAnchorWidth = true, className, dropdownClassName, onButtonClick, children, }) {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const contentRef = useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement(ButtonGroup, { id: id, ref: anchorRef, className: className },
            React.createElement(Button, { isFullWidth: true, id: `${id}-button`, startIcon: startIcon, disabled: disabled, tooltipTitle: tooltipTitle, onClick: onButtonClick }, label),
            React.createElement(Button, { "aria-controls": open ? `${id}-menu` : undefined, "aria-expanded": open ? "true" : undefined, "aria-haspopup": "menu", "aria-label": ariaLabel, disabled: disabled, onClick: () => setOpen((prevOpen) => !prevOpen), className: styles["dropdown-button"] },
                React.createElement(ArrowDropDownIcon, null))),
        React.createElement(Popper, { sx: { zIndex: 1 }, open: open, anchorEl: anchorRef.current, role: undefined, transition: true, modifiers: [
                {
                    name: "sameWidth",
                    enabled: matchAnchorWidth,
                    phase: "beforeWrite",
                    requires: ["computeStyles"],
                    fn: ({ state }) => {
                        state.styles.popper.width = `${state.rects.reference.width}px`;
                    },
                },
            ] }, ({ TransitionProps, placement }) => (React.createElement(Grow, { ...TransitionProps, onEntered: () => {
                var _a, _b;
                (_b = (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('[role="menuitem"]:not([aria-disabled="true"])')) === null || _b === void 0 ? void 0 : _b.focus();
            }, style: {
                transformOrigin: placement === "bottom" ? "center top" : "center bottom",
            } },
            React.createElement(Paper, { elevation: 0, className: getClassName(styles.dropdown, dropdownClassName) },
                React.createElement(ClickAwayListener, { onClickAway: (event) => {
                        if (anchorRef.current &&
                            anchorRef.current.contains(event.target)) {
                            return;
                        }
                        setOpen(false);
                    } },
                    React.createElement("div", { id: `${id}-menu`, ref: contentRef, onClick: () => setOpen(false) }, children))))))));
}
export default SplitButton;
//# sourceMappingURL=SplitButton.js.map